<div class="store-authority-viewer" data-id="storeAuthorityViewer">
  <div class="viewer-head">
    <span class="viewer-level" data-id="storeAuthorityLevel">
      <span class="viewer-accent"></span>
      <span class="viewer-title">Store Authority:</span>
      Level - {{ levelLabel() }}
    </span>

    <div class="viewer-search search-box position-relative" *ngIf="!accessAllStores()">
      <input
        type="text"
        class="searchCriteria form-control"
        data-id="storeAuthoritySearch"
        placeholder="Enter keyword search"
        [value]="searchTerm()"
        (input)="onSearchInput($event.target.value)"
      />
      <em
        class="icon-close-mini"
        aria-hidden="true"
        data-id="storeAuthoritySearchClear"
        [ngClass]="{ 'd-none': !searchTerm() }"
        (click)="clearSearch()"
      ></em>
      <button class="btn-search" type="button">
        <em class="icon-search"></em>
      </button>
    </div>
  </div>

  <div class="viewer-body" *ngIf="!accessAllStores()">
    <app-store-authority-scope-list
      *ngIf="hasScopeList()"
      class="viewer-scope-list"
      [scopes]="sortedScopes()"
      [selectedCode]="selectedScope()?.code"
      (scopeSelected)="onSelectScope($event)"
    ></app-store-authority-scope-list>

    <app-store-authority-store-list
      class="viewer-store-list"
      [stores]="filteredStores()"
      [columns]="columns()"
      [searchTerm]="searchTerm()"
      [bordered]="!isStoreLevel()"
    ></app-store-authority-store-list>
  </div>
</div>
